import '@videojs/react/video/skin.css';
import { createPlayer, videoFeatures } from '@videojs/react';
import { VideoSkin } from '@videojs/react/video';
import { MuxVideo } from '@videojs/react/media/mux-video';

import type { VideoPlayerProps } from '../types';

const Player = createPlayer({ features: videoFeatures });

export default function VideoPlayer({ src, poster }: VideoPlayerProps) {
  return (
    <Player.Provider>
      <VideoSkin poster={poster}>
        <MuxVideo src={src} poster={poster} playsInline />
      </VideoSkin>
    </Player.Provider>
  );
}
